import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { getGoogleLoginUrl } from '../services/authService';

export default function LoginPage() {
  const navigate = useNavigate();
  const { error, isLoading, enterAsGuest } = useAuthStore();

  const handleGoogleLogin = () => {
    // Google OAuth 페이지로 리다이렉트
    window.location.href = getGoogleLoginUrl();
  };

  const handleGuestLogin = () => {
    enterAsGuest();
    navigate('/lobby');
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">환영합니다!</h2>
        <p className="text-slate-400 text-sm">
          실시간 음성 토론 배틀에 참여하세요
        </p>
      </div>

      {error && (
        <div className="p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-300 text-sm">
          {error}
        </div>
      )}

      {/* Google 로그인 버튼 */}
      <button
        onClick={handleGoogleLogin}
        disabled={isLoading}
        className="w-full py-3 px-4 bg-white hover:bg-gray-100 text-gray-800 font-medium 
                   rounded-xl flex items-center justify-center gap-3 
                   transition-all duration-200 disabled:opacity-50"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24">
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
        {isLoading ? '로그인 중...' : 'Google로 계속하기'}
      </button>

      {/* 안내 문구 */}
      <div className="text-center text-slate-500 text-xs">
        <p>로그인 시 서비스 이용약관 및</p>
        <p>개인정보처리방침에 동의하게 됩니다.</p>
      </div>

      {/* 게스트 모드 - 관전만 가능 */}
      <div className="pt-4 border-t border-slate-700">
        <p className="text-center text-slate-500 text-sm mb-3">
          또는
        </p>
        <button
          onClick={handleGuestLogin}
          className="w-full py-2 text-slate-400 hover:text-white text-sm transition-colors"
        >
          👁️ 게스트로 관전하기
        </button>
        <p className="text-center text-slate-500 text-xs mt-2">
          게스트는 토론 관전만 가능합니다
        </p>
      </div>
    </div>
  );
}
